import React from 'react';

export const FormInput = props => {
  // classNameはUIを崩さないようpropsから受け入れない
  const { className, short, large, width, ...rest } = props;
  let classes = `FormInput`;

  // 登録系画面で使用されているInputの横幅
  if (short && !large) {
    classes += ` FormInput--short`;
  }
  if (large && !short) {
    classes += ` FormInput--large`;
  }

  // 検索など横幅を任意にしたいケースが多いためwidth propsで受け取る
  let styles = {};
  if (width) {
    styles = {
      width: `${width}px`,
    };
  }

  return <input {...rest} className={classes} style={{ ...styles }} />;
};



// WEBPACK FOOTER //
// ./src/components/FormInput.jsx